import { Pool_ABI, Pool_Address } from "./constant";
import web3 from "./initWeb3";

export const ContractPool = new web3.eth.Contract(Pool_ABI, Pool_Address);
// export const OldContractPool = new web3.eth.Contract(Pool_ABI, Old_Pool_Address);
